import { HashMap } from '../constants';
import { SimInfo } from '../models/sim';
import { AppState } from '../models/state/appState';
import { SimsState } from '../models/state/simsState';

/**
 * Selects the spend caps.
 * @param state The aplication state.
 */
export function selectSims(state: AppState): SimsState {
  return state.sims;
}

export function selectSelectedSims(state: AppState): HashMap<SimInfo> {
  return state.sims.selected;
}

export function selectViewedSims(state: AppState): HashMap<SimInfo> {
  return state.sims.viewed;
}
